import { styled, Table, TableRow } from '@mui/material'

export const StyledTable = styled(Table)(({ theme }) => ({
  borderTop: '0',
  '& td': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'normal',
    },
  },
}))

export const StyledTableRow = styled(TableRow)({
  '& .MuiTableCell-root': {
    borderTop: '1px solid rgba(0,0,0,.1)',
  },
})
